import { v4 } from 'uuid';

import { iaRa } from 'lib/helpers/utility';

export const addTempIdToInvoice = (invoice = {}) => {
  return {
    ...invoice,
    procedures: iaRa(invoice?.procedures).map((proc) => ({ ...proc, tempId: v4() })),
    products: iaRa(invoice?.products).map((prod) => ({ ...prod, tempId: v4() })),
    packages: iaRa(invoice?.packages).map((pkg) => ({ ...pkg, tempId: v4() }))
  };
};

export const removeTempIdFromInvoice = (invoice = {}) => {
  return {
    ...invoice,
    procedures: iaRa(invoice?.procedures).map(({ tempId: _tempId, ...proc }) => proc),
    products: iaRa(invoice?.products).map(({ tempId: _tempId, ...prod }) => prod),
    packages: iaRa(invoice?.packages).map(({ tempId: _tempId, ...pkg }) => pkg)
  };
};

export const addTempIdToItem = (item = {}) => {
  return {
    ...item,
    tempId: item?.tempId || v4()
  };
};
